import styled from 'styled-components'

export const Box = styled.div`
  display: flex;
  & > i {
    margin-right: 8px;
  }
`
